var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.activeTestMod,{tag:"component",staticClass:"w-full",attrs:{"editTest":_vm.editTest,"tests":_vm.tests,"testsWithKey":_vm.testsWithKey}})}
var staticRenderFns = []

export { render, staticRenderFns }